export const P_VALUE_FILTER_PLACEHOLDER = '4.4e-3';
